
import { Component, Vue } from 'vue-property-decorator'

import { Venue } from '@/types/Company'
import venueModule from '@/store/venue'
import companyModule from '@/store/company'

import VenueEditor from '@/components/company/venue/VenueEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'
import whitelabel from '@/store/whitelabel'

@Component({
  name: 'VenueList',
  components: {
    VenueEditor,
    ContentList
  }
})
class VenueList extends Vue {
  private listType = ListType

  private get storeModule() {
    return venueModule
  }

  private get venues() {
    return venueModule.venues
  }

  private get company() {
    return companyModule.company
  }

  private async setVenue(venue: Venue): Promise<void> {
    await venueModule.setVenue(venue)
    this.$router.push({ name: 'VenueDetail', params: { vid: venue._id } })
  }

  private get headers() {
    return [
      { text: 'Name', value: 'name' },
      ...(whitelabel.whitelabel.flags.externalIds
        ? [{ text: 'Externe ID', value: 'externalId' }]
        : []),
      { text: 'Stadt', value: 'address.city' },
      { text: 'Unternehmen', value: 'company.name' },
      { text: 'Status', value: 'enable' }
    ]
  }

  private get filters(): string[] {
    return ['address.city', 'company.name', 'enable']
  }
}

export default VenueList
